export enum Route {
  Home = "/",
  Question = "/question",
  Loading = "/loading",
  Results = "/results",
}
